import { render, staticRenderFns } from "./ResultsHeading.vue?vue&type=template&id=233ac64c&scoped=true&lang=html"
import script from "./ResultsHeading.vue?vue&type=script&lang=js"
export * from "./ResultsHeading.vue?vue&type=script&lang=js"
import style0 from "./ResultsHeading.vue?vue&type=style&index=0&id=233ac64c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ac64c",
  null
  
)

export default component.exports